import { RRule, type ByWeekday, type Frequency } from "rrule";

export type Interval =
  | "daily"
  | "weekly"
  | "bi-weekly"
  | "monthly"
  | "bi-monthly"
  | "quarterly"
  | "semi-annual"
  | "triquarterly"
  | "annual"
  | "biannual";

export interface IntervalOption {
  value: Interval;
  frequency: { freq: Frequency; interval: number };
}

export const INTERVAL_OPTIONS: IntervalOption[] = [
  { value: "daily", frequency: { freq: RRule.DAILY, interval: 1 } },
  { value: "weekly", frequency: { freq: RRule.WEEKLY, interval: 1 } },
  { value: "bi-weekly", frequency: { freq: RRule.WEEKLY, interval: 2 } },
  { value: "monthly", frequency: { freq: RRule.MONTHLY, interval: 1 } },
  { value: "bi-monthly", frequency: { freq: RRule.MONTHLY, interval: 2 } },
  { value: "quarterly", frequency: { freq: RRule.MONTHLY, interval: 3 } },
  { value: "semi-annual", frequency: { freq: RRule.MONTHLY, interval: 6 } },
  { value: "triquarterly", frequency: { freq: RRule.MONTHLY, interval: 9 } },
  { value: "annual", frequency: { freq: RRule.YEARLY, interval: 1 } },
  { value: "biannual", frequency: { freq: RRule.YEARLY, interval: 2 } },
];
export const MAPPED_INTERVAL_OPTIONS: Record<Interval, IntervalOption> = {
  daily: { value: "daily", frequency: { freq: RRule.DAILY, interval: 1 } },
  weekly: { value: "weekly", frequency: { freq: RRule.WEEKLY, interval: 1 } },
  "bi-weekly": { value: "bi-weekly", frequency: { freq: RRule.WEEKLY, interval: 2 } },
  monthly: { value: "monthly", frequency: { freq: RRule.MONTHLY, interval: 1 } },
  "bi-monthly": { value: "bi-monthly", frequency: { freq: RRule.MONTHLY, interval: 2 } },
  quarterly: { value: "quarterly", frequency: { freq: RRule.MONTHLY, interval: 3 } },
  "semi-annual": { value: "semi-annual", frequency: { freq: RRule.MONTHLY, interval: 6 } },
  triquarterly: { value: "triquarterly", frequency: { freq: RRule.MONTHLY, interval: 9 } },
  annual: { value: "annual", frequency: { freq: RRule.YEARLY, interval: 1 } },
  biannual: { value: "biannual", frequency: { freq: RRule.YEARLY, interval: 2 } },
};

export type WeekdayName = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday";
export interface WeekdayOption {
  value: WeekdayName;
  weekday: ByWeekday;
}

export const WEEKDAYS: WeekdayOption[] = [
  { value: "monday", weekday: RRule.MO },
  { value: "tuesday", weekday: RRule.TU },
  { value: "wednesday", weekday: RRule.WE },
  { value: "thursday", weekday: RRule.TH },
  { value: "friday", weekday: RRule.FR },
  { value: "saturday", weekday: RRule.SA },
  { value: "sunday", weekday: RRule.SU },
];
export const MAPPED_WEEKDAYS: Record<WeekdayName, WeekdayOption> = {
  monday: { value: "monday", weekday: RRule.MO },
  tuesday: { value: "tuesday", weekday: RRule.TU },
  wednesday: { value: "wednesday", weekday: RRule.WE },
  thursday: { value: "thursday", weekday: RRule.TH },
  friday: { value: "friday", weekday: RRule.FR },
  saturday: { value: "saturday", weekday: RRule.SA },
  sunday: { value: "sunday", weekday: RRule.SU },
};
